import { render, staticRenderFns } from "./temporary.vue?vue&type=template&id=025cf940"
import script from "./temporary.vue?vue&type=script&lang=js"
export * from "./temporary.vue?vue&type=script&lang=js"
import style0 from "./temporary.vue?vue&type=style&index=0&id=025cf940&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports